import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useMemo } from 'react';
import { PageBreadcrumbs, PageNavigation } from '@client/toolkit';
import { useGetTenantsCurrentCompanyQuery } from '@client/api';
import { ProfilePaths } from '../profile.router';
import { PageContentAnimation } from '../../../components/layout/page-content-animation';

export const ProfileHeader = () => {
  const { t: tGlobal } = useTranslation('global');
  const { data: company } = useGetTenantsCurrentCompanyQuery();
  const isTenant = company?.roles?.includes('Tenant') ?? false;

  const tabs = useMemo(() => {
    const items = [
      {
        key: 'company',
        label: tGlobal('navigation.profile.company'),
        to: ProfilePaths.Profile,
        end: true,
      },
      {
        key: 'users',
        label: tGlobal('navigation.profile.users'),
        to: ProfilePaths.Users,
        end: false,
      },
      {
        key: 'contactPersons',
        label: tGlobal('navigation.profile.contactPersons'),
        to: ProfilePaths.ContactPersons,
        end: false,
      },
    ];

    if (isTenant) {
      items.push({
        key: 'invoices',
        label: tGlobal('navigation.profile.invoices'),
        to: ProfilePaths.Invoices,
        end: false,
      });
    }

    return items;
  }, [tGlobal, isTenant]);

  return (
    <>
      <PageContentAnimation className="flex flex-col gap-5">
        <PageNavigation>
          <PageBreadcrumbs>
            <PageBreadcrumbs.Link>{tGlobal('navigation.overview')}</PageBreadcrumbs.Link>
            <PageBreadcrumbs.Link>{tGlobal('navigation.profile.label')}</PageBreadcrumbs.Link>
          </PageBreadcrumbs>
        </PageNavigation>
      </PageContentAnimation>
      <PageContentAnimation className="mb-1">
        <div className="flex gap-8 border-b border-border w-full">
          {tabs.map((tab) => (
            <NavLink
              key={tab.key}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                classNames(
                  'pb-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'text-brand-primary border-b-2 border-brand-primary'
                    : 'text-white hover:text-brand-primary',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </PageContentAnimation>
    </>
  );
};
